// extracted by mini-css-extract-plugin
export default {"passwordContainer":"ResetPassword_passwordContainer__VKPQk","error":"ResetPassword_error__e6VZQ","success":"ResetPassword_success__EiaUK"};